import { createEntityAdapter } from '@reduxjs/toolkit';

import type { CartProduct } from './cart_products.types';

const cartProductsAdapter = createEntityAdapter<CartProduct>({
  sortComparer(a, b) {
    return b.id - a.id;
  },
});

export default cartProductsAdapter;
